<template>
<div class="chatContainer">
  <choose-contact v-if="showChooser" @close="closeChooser" />
  <div class="fullScreenMedia fCol jCenter aCenter"
    @mousemove="showBottomMsg(fullScreen.msg)"
    v-if="fullScreen.show">
    <div class="closer" @click="fullScreen.show = false"></div>
    <img
      class="transition-medium"
      v-bind:class="{land: dynamicClass === 'ofoghi',
      port: dynamicClass === 'amoodi',
      square: dynamicClass === 'moraba'}"
       v-if="fullScreen.type === 'photo'"
      :src="fullScreen.media"
      @load="photoDimension"
      ref="photo">
    <video
      v-bind:class="{land: dynamicClass === 'ofoghi',
      port: dynamicClass === 'amoodi',
      square: dynamicClass === 'moraba'}"
      controls ref="video"
      @loadeddata="videoDimension"
      v-if="fullScreen.type === 'video'">
      <source :src="fullScreen.media" type="video/mp4">
      Your browser does not support HTML video.
    </video>
    <div ref="bottomMsg"
      class="msg transition-fast" v-if="fullScreen.msg !== ''">{{fullScreen.msg}}</div>
  </div>
  <!-- لیست چت -->
  <div class="chatList" v-bind:class="{hideChatList: convIsOpen}">
    <div class="fRow fullWidth jStart aCenter searchHead secondary">
      <input type="text" placeholder="جستجو در پیام‌ها"
        v-model="search" class="fullWidth growFull" />
      <i class="material-icons-round transition-medium" v-ripple
        v-bind:class="{active: search.length > 0}">search</i>
    </div>
    <!-- آیتم -->
    <chat-list-item
      v-for="(chat, index) in chats" v-bind:key="index"
      :name="chat.name"
      :state='chat.online'
      :avatar="chat.avatar"
      :type="chat.type"
      :unread='chat.unread'
      :lastDate='chat.lastDate'
      :lastMessage='chat.messages[chat.messages.length - 1].message'
      :lastState='chat.messages[chat.messages.length - 1].state'
      @click.native="openChat(chat.chatId)"/>
  </div>
  <!-- صفحه ی چت -->
  <div class="chatScreen fCol jCenter aCenter">
    <div class="emojiHolder" v-if="emoji" v-bind:style="{bottom: computedEmojiBottom}">
      <picker :data="emojiIndex"
        :native="true"
        :showPreview="false"
        :i18n="{
          search: 'جستجو',
          categories: {
            search: 'نتیجه جستجو',
            recent: 'اخیراً استفاده شده',
            smileys: 'شکلک‌ها',
            people: 'افراد و حالت‌های بدن',
            nature: 'طبیعت و حیوانات',
            foods: 'غذاها و میوه‌ها',
            activity: 'فعالیت‌ها',
            places: 'مکان‌ها',
            objects: 'اشیاء',
            symbols: 'نماد‌ها',
            flags: 'پرچم‌ها',
            custom: 'شخصی سازی شده',
            },
          }"
        @select="addEmoji($event)"/>
    </div>
    <div class="fCol jCenter aCenter noContent" v-if="!convIsOpen">
      <div class="noChat">ابتدا یک گفتگو را انتخاب کنید یا پیام جدیدی ارسال کنید</div>
      <btn label='ارسال پیام جدید' icon='maps_ugc' @click.native="showChooseContact"/>
      <btn label='ارسال پیام به پشتیبان سیستم' icon='info' :isMini='true' bc='#ea8f25' />
    </div>
    <div class="conversationBox" id="convBox" v-if="convIsOpen">
      <div class="conversation" id="conv" ref="conversation"
        v-bind:class="{blur: attachBox,
        activeReply: hasReply}">
        <div class="noMsgYet"></div>
        <msg v-for="(item, index) in activeConversation.messages"
          v-bind:key="index"
          :sender="item.sender"
          :message="item.message"
          :media="item.media"
          :id="item.id"
          :thumb="item.thumb"
          :type="item.type"
          :replyTo="item.replyTo"
          @openPhoto=openPhotoBox($event)
          :index="index"/>
        <!-- <div @click="goDown" class="goBottom">برو پایین</div> -->
      </div>
      <!-- ⤵options⤵ -->
      <div class="options fCol jStart aCenter" ref="optionBar">
        <div class="replyBox fullWidth" v-if="replyMode.id !== '' && replyMode.id !== undefined">
          <div class="holder fRow jStart aCenter">
            <div class="mediaPreview"
              v-if="replyHasMedia">
              <img :src="replyMode.thumb">
            </div>
            <div class="replyContent fCol jCenter aStart growFull">
              <div class="to" v-if="replyMode.sender !== 'you'">
                پاسخ به {{activeConversation.name}}</div>
              <div class="to" v-if="replyMode.sender === 'you'">پاسخ به خودتان</div>
              <div class="msgPreview">{{replyMode.message}}</div>
            </div>
            <i class="cancelReply material-icons-round" @click="clearReply">close</i>
          </div>
        </div>
        <div class="fRow jStart aCenter fullWidth" style="min-height: 64px">
          <i class="material-icons-round delete transition-fast" v-if="recording">delete</i>
          <div class="recordingCaption fRow jCenter aCenter"
            v-bind:style="{opacity: `${1 - (recordDelta.x / 500)}`}"
            v-if="recording">
            <span>در حال ضبط</span>
            <label>00:00</label>
          </div>
          <v-touch
            style="z-index: 20000"
            v-bind:style="{marginRight: `${recordDelta.x}px`, marginBottom: `${recordDelta.y}px`}"
            v-bind:class="{'transition-fast': !recording}"
            @tap="tap($event)"
            @press="pressed($event)"
            @pressup="pressup($event)"
            @pan="pan($event)">
            <i class="material-icons-round" ref="mic"
              v-if="!isTyping"
              v-bind:class="{recording: recording}" v-ripple>mic</i>
          </v-touch>
          <i class="material-icons-round transition-fast"
          v-if="!isTyping && !recording"
          v-ripple @click="showAttachBox">attach_file</i>
          <i class="material-icons-round transition-fast"
          v-if="false" v-ripple>camera_alt</i>
          <i class="material-icons-round transition-fast"
            @click="sendMsg"
            v-if="isTyping && !recording" v-ripple>send</i>
          <i class="material-icons-round transition-fast emoji" @click="emojiHandle('toggle')"
            v-if="!recording" v-bind:class="{emojiActive: emoji}" v-ripple>mood
          </i>
          <input type="text" placeholder="متن پیام را وارد کنید"
            @keyup.enter="sendMsg" ref="msg"
            v-if="!recording" v-model="msg">
        </div>
      </div>
      <div class="selectedMenu fRow jStart aCenter transition-fast"
        v-bind:class="{active: this.selecteds.length > 0}">
        <i class="material-icons-round mainIcon">rule</i>
        <div class="selectedsInfo fCol jCenter aStart">
          <label class="fRow jCenter aCenter">{{this.selecteds.length}}
            <div class="i">پیام</div>
          </label>
          <span>انتخاب شده</span>
        </div>
        <div class="selectedOptions fRow jEnd aCenter growFull">
          <i class="material-icons-round" v-if="this.selecteds.length === 1" v-ripple>reply_all</i>
          <i class="material-icons-round" v-ripple>forward</i>
          <i class="material-icons-round" v-ripple style="color: red">delete_outline</i>
          <i class="material-icons-round close" v-ripple @click="clearSelection">close</i>
        </div>
      </div>
      <div class="attachHolder" v-if="attachBox">
        <div class="closer" @click="hideAttachBox">
          <i class="material-icons-round close" @click="hideAttachBox">close</i>
        </div>
        <div class="attachBox fCol jStart aCenter">
          <div class="contents growFull fullWidth">
            <div class="attachPage fullWidth fCol jCenter aCenter"
              v-if="selectedAttach === 0">
              <div class="dropFile fCol jCenter aCenter transition-fast"
                @click="selectFile('gallery')">
                <i class="material-icons-round">photo_size_select_actual</i>
                <div class="title">انتخاب عکس و ویدئو</div>
                <div class="desc">
                  :پسوند‌های مجاز<br><br>
                  <div class="ext" v-for="item in galleryExtension" v-bind:key="item">{{item}}</div>
                </div>
              </div>
              <input type="file" ref="getGallery">
            </div>
            <div class="attachPage fullWidth fCol jCenter aCenter"
              v-if="selectedAttach === 1">
              <div class="dropFile fCol jCenter aCenter transition-fast"
                @click="selectFile('gallery')">
                <i class="material-icons-round">add_a_photo</i>
                <div class="title">دوربین</div>
                <div class="desc">
                  :پسوند‌های مجاز<br><br>
                  <div class="ext" v-for="item in galleryExtension" v-bind:key="item">{{item}}</div>
                </div>
              </div>
              <input type="file" ref="getGallery">
            </div>
            <div class="attachPage fullWidth fCol jCenter aCenter"
              v-if="selectedAttach === 2">
              <div class="dropFile fCol jCenter aCenter transition-fast"
                @click="selectFile('file')">
                <i class="material-icons-round">insert_drive_file</i>
                <div class="title">انتخاب فایـل</div>
                <div class="desc">
                  :پسوند‌های مجاز<br><br>
                  <div class="ext" v-for="item in fileExtension"
                    v-bind:key="item">{{item}}</div><br>
                  ...
                </div>
              </div>
              <input type="file" ref="fileGallery">
            </div>
            <div class="attachPage fullWidth fCol jCenter aCenter"
              v-if="selectedAttach === 3">
              <div class="dropFile fCol jCenter aCenter transition-fast disable">
                <i class="material-icons-round">place</i>
                <div class="title">انتخاب موقعیت مکانی</div>
                <div class="desc">به زودی...</div>
              </div>
            </div>
            <div class="attachPage fullWidth fCol jCenter aCenter"
              v-if="selectedAttach === 4">
              <div class="dropFile fCol jCenter aCenter transition-fast disable">
                <i class="material-icons-round">contact_page</i>
                <div class="title">انتخاب و ارسال مخاطب</div>
                <div class="desc">به زودی...</div>
              </div>
            </div>
          </div>
          <div class="bottom fRow jCenter aCenter">
            <div class="attachType fCol jCenter aCenter transition-fast"
              v-ripple
              @click="chooseAttachType(index)"
              v-for="(btn, index) in attachBtn" v-bind:key="btn.action"
              v-bind:class="{selected: selectedAttach === index}">
              <i class="material-icons-round icon">{{btn.icon}}</i>
              <label>{{btn.label}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="head secondary transition-cubic"
        v-bind:class="{open: conversationStates.isMoreInfo}">
        <!-- .infos -->
        <div class="infos fRow jStart fullWidth transition-cubic">
          <div class="avatar transition-cubic"
             v-bind:class="{offline: !activeConversation.online}"
            @click="openMoreInfo('open')">
            <img src="../assets/av.jpg" alt="">
          </div>
          <h3 class="transition-cubic">{{activeConversation.name}}</h3>
          <div class="bio transition-cubic" v-bind:style="{height: `${bioHeight}px`}" ref="bio">
            <span>درباره</span>
            <div class="bioText">{{activeConversation.bio}}</div>
          </div>
          <div class="fRow jStart aCenter states transition-cubic">
            <div class="state" v-bind:class="{online: activeConversation.online}"></div>
            <span v-bind:class="{online: activeConversation.online}">آنلاین</span>
          </div>
          <div class="option fRow jCenter aCenter">
            <div class="btnOption">
              <i class="material-icons-round" v-ripple>more_vert</i>
              <div class="dropDown primary transition-fast">
                <div class="item fullWidth fRow jStart aCenter">
                  <i class="material-icons-round">search</i>
                  <label>جستجو در پیام‌ها</label>
                </div>
                <div class="item fullWidth fRow jStart aCenter">
                  <i class="material-icons-round">block</i>
                  <label>بلاک و ریپورت</label>
                </div>
              </div>
            </div>
            <i class="material-icons-round"
              v-if="!conversationStates.isMoreInfo" v-ripple>keyboard_backspace</i>
            <i class="material-icons-round"
              v-if="conversationStates.isMoreInfo"
              v-ripple @click="openMoreInfo('close')">close</i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fabsMenu fCol jStart aStart transition-cubic"
    v-bind:class="{open: fabState.isOpen}">
    <btn label='ارسال پیام جدید' icon='maps_ugc' @click.native="showChooseContact"/>
    <btn label='پیام به پشتیبان' icon='info' :isMini='true' bc='#ea8f25' />
  </div>
  <div class="fabsHolder fCol jEnd aStart">
    <btn label='گفتگوی جدید' icon='add' :fabBtn='true' :bc='fabColor'
      class="add transition-cubic" v-bind:class="{open: fabState.isOpen}"
      @click.native="toggleNewCoversation"/>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import Btn from '@/components/Btn.vue';
import ChatListItem from '@/components/ChatListItem.vue';
import Msg from '@/components/Msg.vue';
import ChooseContact from '@/components/ChooseContact.vue';
import data from 'emoji-mart-vue-fast/data/all.json';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';

export default {
  name: 'Chat',
  data() {
    return {
      msg: '',
      showChooser: false,
      isReply: false,
      forTestIndex: 0,
      replyHasMedia: false,
      emojiIndex: '',
      emojiBottom: 0,
      emoji: false,
      attachBox: false,
      recording: false,
      recordTransition: false,
      recordDelta: {
        x: 0,
        y: 0,
      },
      fabState: {
        isOpen: false,
        anyFabs: true,
      },
      chats: [
        {
          pinned: false,
          chatId: 68433146,
          type: 0,
          unread: 4,
          avatar: 'https://api.rimik.ir/photo/a1725f08-1afb-4307-8987-8760c593c0e3.jpg',
          lastDate: '1 روز پیش',
          name: 'علیرضا عباسپور',
          bio: 'من علیرضا هستم، دانشجوی رشته ریاضی ریمیک',
          online: true,
          messages: [
            {
              message: '',
              sender: 'you',
              id: 684,
              type: 'photo',
              state: 3,
              thumb: '/static/test0.gif',
              media: '/static/test0.gif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 6843454,
              type: 'photo',
              thumb: '/static/test3.jfif',
              media: '/static/test3.jfif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 68432454,
              type: 'photo',
              thumb: '/static/test2.jpg',
              media: '/static/test2.jpg',
            },
            {
              message: '',
              sender: 'other',
              id: 34444445,
              type: 'voice',
              media: '/static/bar.ogg',
            },
            {
              message: 'ویدئو رو ببین',
              sender: 'you',
              id: 34444424445,
              type: 'video',
              media: '/static/vid1.mp4',
              thumb: '/static/vid1.jpg',
            },
            {
              message: 'اینو هم ببین',
              sender: 'you',
              id: 3474442445,
              type: 'video',
              state: 3,
              media: '/static/vid2.mp4',
              thumb: '/static/vid2.jpg',
            },
            {
              message: '',
              sender: 'you',
              id: 3444442,
              type: 'video',
              state: 3,
              media: '/static/vid3.mp4',
              thumb: '/static/vid3.jpg',
            },
            {
              message: '',
              sender: 'other',
              id: 34444495572,
              type: 'video',
              media: '/static/vid4.mp4',
              thumb: '/static/vid4.jpg',
            },
            {
              message: 'کجایی پس',
              sender: 'you',
              id: 35,
              type: 'voice',
              state: 2,
              media: '/static/long.mp3',
              replyTo: {
                message: 'ویدئو رو ببین',
                sender: 'other',
                id: 34444424445,
                type: 'video',
                thumb: '/static/vid1.jpg',
              },
            },
            {
              message: 'سلام کلاس ریاضی ساعت 6',
              sender: 'you',
              id: 4684,
              state: 1,
              type: 'text',
              replyTo: {
                id: '35',
                sender: 'you',
                thumb: '',
                type: 'voice',
                message: 'کجایی پس',
              },
            },
            {
              message: 'همین؟',
              sender: 'you',
              state: 0,
              id: 3384,
              type: 'text',
            },
          ],
        },
        {
          chatId: 66846328422146,
          type: 1,
          unread: 164,
          pinned: true,
          avatar: '',
          lastDate: '1 روز پیش',
          name: 'گروه ریاضی سوم',
          bio: 'من علیرضا هستم، دانشجوی رشته ریاضی ریمیک',
          online: true,
          messages: [
            {
              message: '',
              sender: 'you',
              id: 684,
              type: 'photo',
              state: 3,
              thumb: '/static/test0.gif',
              media: '/static/test0.gif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 6843454,
              type: 'photo',
              thumb: '/static/test3.jfif',
              media: '/static/test3.jfif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 68432454,
              type: 'photo',
              thumb: '/static/test2.jpg',
              media: '/static/test2.jpg',
            },
          ],
        },
        {
          chatId: 699328422146,
          type: 0,
          unread: 0,
          pinned: false,
          avatar: 'https://api.rimik.ir/photo/6f2a67c8-2623-4400-b565-e9890e800351.jpg',
          lastDate: '1 روز پیش',
          name: 'فاطمه ابطحی',
          bio: '',
          online: true,
          messages: [
            {
              message: '',
              sender: 'you',
              id: 684,
              type: 'photo',
              state: 3,
              thumb: '/static/test0.gif',
              media: '/static/test0.gif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 6843454,
              type: 'photo',
              thumb: '/static/test3.jfif',
              media: '/static/test3.jfif',
            },
            {
              message: 'سلام تو خوبی؟',
              sender: 'other',
              id: 68432454,
              type: 'photo',
              thumb: '/static/test2.jpg',
              media: '/static/test2.jpg',
            },
          ],
        },
        {
          chatId: 6843315645146,
          type: 0,
          unread: 4,
          avatar: 'https://api.rimik.ir/photo/801b19c4-78cc-42b5-ac63-25cc3dabbd1e.jpg',
          lastDate: '1 روز پیش',
          name: 'احمد رضایی',
          bio: 'من علیرضا هستم، دانشجوی رشته ریاضی ریمیک',
          online: false,
          messages: [
            {
              message: 'اینو هم ببین',
              sender: 'you',
              id: 3474442445,
              type: 'video',
              state: 3,
              media: '/static/vid2.mp4',
              thumb: '/static/vid2.jpg',
            },
            {
              message: '',
              sender: 'you',
              id: 3444442,
              type: 'video',
              state: 3,
              media: '/static/vid3.mp4',
              thumb: '/static/vid3.jpg',
            },
            {
              message: '',
              sender: 'other',
              id: 34444495572,
              type: 'video',
              media: '/static/vid4.mp4',
              thumb: '/static/vid4.jpg',
            },
            {
              message: 'کجایی پس',
              sender: 'you',
              id: 35,
              type: 'voice',
              state: 2,
              media: '/static/long.mp3',
              replyTo: {
                message: 'ویدئو رو ببین',
                sender: 'other',
                id: 34444424445,
                type: 'video',
                thumb: '/static/vid1.jpg',
              },
            },
            {
              message: 'سلام کلاس ریاضی ساعت 6',
              sender: 'you',
              id: 4684,
              state: 1,
              type: 'text',
              replyTo: {
                id: '35',
                sender: 'you',
                thumb: '',
                type: 'voice',
                message: 'کجایی پس',
              },
            },
            {
              message: 'همین؟',
              sender: 'you',
              state: 2,
              id: 3384,
              type: 'text',
            },
          ],
        },
      ],
      user1: {
        chatId: 6843315146,
        type: 'private',
        avatar: 'https://api.rimik.ir/photo/a1725f08-1afb-4307-8987-8760c593c0e3.jpg',
        lastMessage: '1 روز پیش',
        name: 'علیرضا عباسپور',
        bio: 'من علیرضا هستم، دانشجوی رشته ریاضی ریمیک',
        online: true,
        messages: [
          {
            message: '',
            sender: 'you',
            id: 684,
            type: 'photo',
            state: 3,
            thumb: '/static/test0.gif',
            media: '/static/test0.gif',
          },
          {
            message: 'سلام تو خوبی؟',
            sender: 'other',
            id: 6843454,
            type: 'photo',
            thumb: '/static/test3.jfif',
            media: '/static/test3.jfif',
          },
          {
            message: 'سلام تو خوبی؟',
            sender: 'other',
            id: 68432454,
            type: 'photo',
            thumb: '/static/test2.jpg',
            media: '/static/test2.jpg',
          },
          {
            message: '',
            sender: 'other',
            id: 34444445,
            type: 'voice',
            media: '/static/bar.ogg',
          },
          {
            message: 'ویدئو رو ببین',
            sender: 'you',
            id: 34444424445,
            type: 'video',
            media: '/static/vid1.mp4',
            thumb: '/static/vid1.jpg',
          },
          {
            message: 'اینو هم ببین',
            sender: 'you',
            id: 3474442445,
            type: 'video',
            state: 3,
            media: '/static/vid2.mp4',
            thumb: '/static/vid2.jpg',
          },
          {
            message: '',
            sender: 'you',
            id: 3444442,
            type: 'video',
            state: 3,
            media: '/static/vid3.mp4',
            thumb: '/static/vid3.jpg',
          },
          {
            message: '',
            sender: 'other',
            id: 34444495572,
            type: 'video',
            media: '/static/vid4.mp4',
            thumb: '/static/vid4.jpg',
          },
          {
            message: 'کجایی پس',
            sender: 'you',
            id: 35,
            type: 'voice',
            state: 2,
            media: '/static/long.mp3',
            replyTo: {
              message: 'ویدئو رو ببین',
              sender: 'other',
              id: 34444424445,
              type: 'video',
              thumb: '/static/vid1.jpg',
            },
          },
          {
            message: 'سلام کلاس ریاضی ساعت 6',
            sender: 'you',
            id: 4684,
            state: 1,
            type: 'text',
            replyTo: {
              id: '35',
              sender: 'you',
              thumb: '',
              type: 'voice',
              message: 'کجایی پس',
            },
          },
          {
            message: 'همین؟',
            sender: 'you',
            state: 0,
            id: 3384,
            type: 'text',
          },
        ],
      },
      conversationStates: {
        isMoreInfo: false,
      },
      search: '',
      conversationTemp: [
        {
          message: '',
          sender: 'you',
          id: 684,
          type: 'photo',
          thumb: '/static/test0.gif',
          media: '/static/test0.gif',
        },
        {
          message: 'سلام تو خوبی؟',
          sender: 'other',
          id: 6843454,
          type: 'photo',
          thumb: '/static/test3.jfif',
          media: '/static/test3.jfif',
        },
        {
          message: 'سلام تو خوبی؟',
          sender: 'other',
          id: 68432454,
          type: 'photo',
          thumb: '/static/test2.jpg',
          media: '/static/test2.jpg',
        },
        {
          message: '',
          sender: 'other',
          id: 34444445,
          type: 'voice',
          media: '/static/bar.ogg',
        },
        {
          message: 'ویدئو رو ببین',
          sender: 'other',
          id: 34444424445,
          type: 'video',
          media: '/static/vid1.mp4',
          thumb: '/static/vid1.jpg',
        },
        {
          message: 'اینو هم ببین',
          sender: 'you',
          id: 3474442445,
          type: 'video',
          media: '/static/vid2.mp4',
          thumb: '/static/vid2.jpg',
        },
        {
          message: '',
          sender: 'you',
          id: 3444442,
          type: 'video',
          media: '/static/vid3.mp4',
          thumb: '/static/vid3.jpg',
        },
        {
          message: '',
          sender: 'other',
          id: 34444495572,
          type: 'video',
          media: '/static/vid4.mp4',
          thumb: '/static/vid4.jpg',
        },
        {
          message: 'کجایی پس',
          sender: 'you',
          id: 35,
          type: 'voice',
          media: '/static/long.mp3',
          replyTo: {
            message: 'ویدئو رو ببین',
            sender: 'other',
            id: 34444424445,
            type: 'video',
            thumb: '/static/vid1.jpg',
          },
        },
        {
          message: 'سلام کلاس ریاضی ساعت 6',
          sender: 'other',
          id: 4684,
          type: 'text',
          replyTo: {
            id: '35',
            sender: 'you',
            thumb: '',
            type: 'voice',
            message: 'کجایی پس',
          },
        },
        {
          message: 'همین؟',
          sender: 'you',
          id: 3384,
          type: 'text',
        },
      ],
      fullScreen: {
        show: false,
        media: '',
        type: '',
        orientation: '',
      },
      attachBtn: [
        {
          icon: 'photo_size_select_actual',
          action: 'gallery',
          label: 'گالری',
        },
        {
          icon: 'add_a_photo',
          action: 'camera',
          label: 'دوربین',
        },
        {
          icon: 'insert_drive_file',
          action: 'file',
          label: 'فایل',
        },
        {
          icon: 'location_on',
          action: 'location',
          label: 'لوکیشن',
        },
        {
          icon: 'contact_page',
          action: 'contact',
          label: 'مخاطب',
        },
      ],
      galleryExtension: [
        '.jpg', '.png', '.jpeg', '.jfif', '.webp', '.gif', '.mp4',
      ],
      fileExtension: [
        '.docx', '.doc', '.pdf', '.pptx', '.ppt', '.mp3', '.mp4',
      ],
      selectedAttach: 0,
      isVideo: false,
      isBottomMsg: false,
      mediaOrientation: '',
      conversation: [],
      convIsOpen: false,
      isTyping: false,
    };
  },
  methods: {
    closeChooser() {
      this.showChooser = false;
    },
    showChooseContact() {
      this.fabState.isOpen = false;
      this.showChooser = true;
    },
    openChat(id) {
      const inx = this.findWithAttr(this.chats, 'chatId', id);
      this.forTestIndex = inx;
      this.$store.commit('setActiveConversation', this.chats[inx]);
      // console.warn('hi nigga');
      this.convIsOpen = true;
      this.conversation = this.activeConversation;
      setTimeout(() => {
        this.goDown();
      }, 300);
    },
    findWithAttr(array, attr, value) {
      for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    randomId() {
      return Math.floor((Math.random() * 100000000) + 1000);
    },
    clearReply() {
      this.$store.commit('clearReply');
    },
    randomUser() {
      if (Math.floor((Math.random() * 2) + 1) === 1) {
        return 'you';
      }
      return 'other';
    },
    sendMsg() {
      if (this.msg.length !== 0) {
        if (this.hasReply) {
          this.$store.commit('newMessage',
            {
              message: this.msg,
              sender: this.randomUser(),
              id: this.randomId(),
              state: 3,
              type: 'text',
              replyTo: this.$store.state.messageToReply,
            });
        } else {
          this.$store.commit('newMessage',
            {
              message: this.msg,
              sender: this.randomUser(),
              state: 3,
              id: this.randomId(),
              type: 'text',
            });
        }
        this.$nextTick(() => {
          this.goDown();
          this.clearReply();
          this.emojiHandle('close');
          this.msg = '';
        });
      }
    },
    emojiHandle(order) {
      switch (order) {
        case 'toggle': {
          this.emoji = !this.emoji;
          break;
        }
        case 'show': {
          this.emoji = true;
          break;
        }
        case 'close': {
          if (this.emoji) {
            this.emoji = false;
            this.$refs.msg.focus();
          }
          break;
        }
        default:
          break;
      }
    },
    tap() {
      if (this.recording) {
        this.emojiHandle('close');
        this.recordDelta = {
          x: 0,
          y: 0,
        };
        this.recording = false;
      } else {
        this.emojiHandle('close');
        this.recording = true;
      }
    },
    pressed() {
      if (!this.recording) {
        this.emojiHandle('close');
        this.recording = true;
      }
    },
    pressup() {
      if (this.recording) {
        this.recordDelta = {
          x: 0,
          y: 0,
        };
        this.recording = false;
      }
    },
    pan(e) {
      let dx = Math.abs(e.deltaX);
      let dy = Math.abs(e.deltaY);
      if (e.deltaX < 0) {
        if (dx > 20) {
          dy = 0;
        }
        if (dy > 20) {
          dx = 0;
        }
        if (this.recording) {
          this.recordDelta.x = dx;
          this.recordDelta.y = dy;
        }
      }
      if (e.isFinal && this.recording) {
        if (dx > 300) {
          this.recording = false;
          this.toast = this.$toasted.show('صدای ضبط شده حذف شد');
        } else if (dy > 100) {
          //
        } else {
          this.recording = true;
        }
        this.recordDelta = {
          x: 0,
          y: 0,
        };
      }
    },
    addEmoji(e) {
      this.msg += e.native;
      this.msg += ' ';
      this.$refs.msg.focus();
    },
    showAttachBox() {
      this.emojiHandle('close');
      this.attachBox = true;
    },
    hideAttachBox() {
      this.emojiHandle('close');
      this.attachBox = false;
    },
    chooseAttachType(index) {
      this.selectedAttach = index;
    },
    selectFile(inp) {
      switch (inp) {
        case 'gallery': {
          this.$refs.getGallery.click();
          break;
        }
        case 'file': {
          this.$refs.fileGallery.click();
          break;
        }
        default:
          break;
      }
    },
    openPhotoBox(e) {
      this.fullScreen = {
        show: true,
        media: e.media,
        msg: e.msg,
        type: e.type,
      };
    },
    closePhotoBox() {
      this.fullScreen.show = false;
      this.mediaOrientation = '';
      this.isBottomMsg = false;
    },
    photoDimension() {
      const h = this.$refs.photo.height;
      const w = this.$refs.photo.width;
      if (w > h) {
        this.mediaOrientation = 'ofoghi';
      } else if (w < h) {
        this.mediaOrientation = 'amoodi';
      } else {
        this.mediaOrientation = 'moraba';
      }
    },
    videoDimension() {
      const h = this.$refs.video.videoHeight;
      const w = this.$refs.video.videoWidth;
      if (w > h) {
        this.mediaOrientation = 'ofoghi';
      } else if (w < h) {
        this.mediaOrientation = 'amoodi';
      } else {
        this.mediaOrientation = 'moraba';
      }
      this.$refs.video.play();
    },
    showBottomMsg(m) {
      if (m !== '' && this.fullScreen.show) {
        if (!this.isBottomMsg) {
          this.isBottomMsg = true;
          this.$refs.bottomMsg.style.opacity = '1';
          setTimeout(() => {
            if (this.isBottomMsg && this.fullScreen.show) {
              this.$refs.bottomMsg.style.opacity = '0';
              this.isBottomMsg = false;
            }
          }, 3000);
        }
      }
    },
    toggleNewCoversation() {
      this.fabState.isOpen = !this.fabState.isOpen;
    },
    goDown() {
      const el = document.getElementById('conv');
      el.scroll({
        top: el.scrollHeight,
      });
    },
    showConv() {
      this.conversation = this.activeConversation;
      this.convIsOpen = true;
      setTimeout(() => {
        this.goDown();
      }, 300);
    },
    inputFocused() {
      this.isTyping = true;
    },
    inputBlured() {
      this.isTyping = false;
    },
    // ui set check
    showAvatar(index) {
      let show = true;
      // eslint-disable-next-line
      if (index === 0) {
        return show;
      }
      const prev = this.conversation[index - 1].sender;
      const now = this.conversation[index].sender;
      // eslint-disable-next-line
      // const now = document.getElementById(`m${index}`);
      if (now !== prev) {
        show = false;
      } else {
        show = true;
      }
      return show;
    },
    openMoreInfo(order) {
      switch (order) {
        case 'open': {
          this.conversationStates.isMoreInfo = true;
          break;
        }
        case 'close': {
          this.conversationStates.isMoreInfo = false;
          break;
        }
        default:
          break;
      }
    },
    clearSelection() {
      this.$store.commit('clearSelection');
    },
  },
  watch: {
    msg() {
      if (this.msg !== '') {
        this.isTyping = true;
      } else {
        this.isTyping = false;
      }
    },
    selecteds() {
      if (this.selecteds.length === 0) {
        this.selected = false;
        this.selectMode = false;
      }
    },
    replyMode() {
      const isVideo = this.replyMode.type === 'video';
      const isVoice = this.replyMode.type === 'voice';
      const isFile = this.replyMode.type === 'file';
      const isPhoto = this.replyMode.type === 'photo';
      this.replyHasMedia = isVideo || isVoice || isFile || isPhoto;
    },
  },
  computed: {
    activeConversation() {
      // console.log('------');
      return this.$store.state.conversation;
    },
    fabColor() {
      let clr = '';
      if (this.fabState.isOpen) {
        clr = '#a04512';
      } else {
        clr = '#2b003a';
      }
      return clr;
    },
    bioHeight() {
      if (this.conversationStates.isMoreInfo) {
        return (this.$refs.bio.scrollHeight + 16);
      }
      return 0;
    },
    dynamicClass() {
      return this.mediaOrientation;
    },
    selecteds() {
      return this.$store.state.selectedMessages;
    },
    computedEmojiBottom() {
      return `${this.$refs.optionBar.scrollHeight}px`;
    },
    replyMode() {
      return this.$store.state.messageToReply;
    },
    hasReply() {
      const [id] = [this.$store.state.messageToReply.id];
      return id !== undefined && id !== '';
    },
  },
  components: {
    ChatListItem,
    Btn,
    Msg,
    Picker,
    ChooseContact,
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.commit('setLoadingOff');
      this.emojiIndex = new EmojiIndex(data);
    });
  },
};
</script>

<style lang='scss' scoped >
$dead: #838383;
$active: #242424;
$primary: #61187A;
$secondary: #2b003a;
$head: #2b003a;
$chatAvatar: 40px;
$openChatAvatar: 164px;
* {
  scroll-behavior: smooth;
}
.chatContainer{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 56px;
  overflow: hidden;
  box-shadow: 0 0 0 20vw rgba($color: #61187A, $alpha: 0.15),
  0 0 24px 0px rgba($color: #000000, $alpha: 0.25);
  ::placeholder {
    color: $dead;
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: $dead;
  }
  ::-ms-input-placeholder { /* Microsoft Edge */
  color: $dead;
  }
  * {
    user-select: none;
  }
  .fullScreenMedia {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 56px;
    right: 0;
    z-index: 900000000000000000000;
    .closer {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.721);
      z-index: 20;
    }
    img, video {
      z-index: 50;
      border-radius: 8px;
      opacity: 0;
      transform: translateY(180px);
      box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.35);
    }
    .msg {
      font-size: 14px;
      font-weight: 300;
      color: white;
      z-index: 60;
      padding: 16px;
      position: absolute;
      pointer-events: none;
      opacity: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgb(0,0,0);
      background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);
    }
  }
  .fabsMenu {
    position: absolute;
    z-index: 300;
    bottom: 64px;
    right: 8px;
    transform: translate(calc(100% + 8px));
    * {
      margin: 0px;
      margin-top: 8px;
    }
  }
  .fabsMenu.open {
    transform: translate(0);
  }
  .fabsHolder {
    position: absolute;
    z-index: 300;
    bottom: 8px;
    right: 8px;
    border-radius: 50px;
    box-shadow: 0 0px 16px 0 rgba(0, 0, 0, 0.096);
    .add {
      transform: rotate(0deg);
    }
    .add.open {
      transform: rotate(-135deg);
    }
  }
  .chatList {
    position: absolute;
    z-index: 200;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0px;
    background-color: white;
    box-shadow: 4px 0px 16px 0 rgba($color: #000000, $alpha: 0.1);
    overflow-x: hidden;
    overflow-y: auto;
    .searchHead {
      min-height: 56px;
      input[type='text'] {
        padding: 16px 16px 16px 0;
        color: #ffffff;
        font-weight: 300;
        background-color: rgba($color: #000000, $alpha: 0.0);
        outline: none;
        border: none;
      }
      i {
        padding: 8px;
        margin-left: 8px;
        border-radius: 50%;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.219);
      }
      i.active{
        color: rgb(255, 255, 255);
      }
    }
  }
  .chatScreen {
    position: absolute;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0px;
    background-color: white;
    .emojiHolder {
      position: absolute;
      box-shadow: 0 -16px 32px 0 rgba($color: #000000, $alpha: 0.35);
      right: 0;
      left: 0;
      z-index: 18;
    }
    .noContent {
      .noChat {
        font-size: 14px;
        font-weight: 300;
        margin-bottom: 16px;
        padding-bottom: 14px;
        color: white;
        border-bottom: dashed 1px rgba($color: #ffffff, $alpha: 0.25);
      }
    }
    .conversationBox {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      overflow: hidden;
      .conversation {
        position: absolute;
        z-index: 10;
        top: 56px;
        left: 0;
        right: 0;
        bottom: 64px;
        padding: 16px 0px 8px;
        direction: ltr;
        overflow-x: hidden;
        overflow-y: scroll;
      }
      .conversation.blur {
        filter: blur(8px);
      }
      .conversation.activeReply {
        bottom: calc(64px + 72px) !important;
      }
      .options {
        position: absolute;
        z-index: 20;
        bottom: 0;
        left: 0;
        right: 0;
        min-height: 64px;
        padding: 0px 8px;
        background-color: white;
        box-shadow: 0 0px 24px 0 rgba($color: #000000, $alpha: 0.15);
        .replyBox {
          min-height: 48px;
          padding: 8px;
          .holder {
            padding: 8px;
            border-radius: 12px;
            border-right: solid 4px $primary;
            .mediaPreview {
              width: 40px;
              height: 40px;
              min-width: 40px;
              background-color: rgba(41, 0, 58, 0.178);
              position: relative;
              border-radius: 8px;
              overflow: hidden;
              margin-left: 8px;
              img {
                position: absolute;
                width: 100%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
            .replyContent {
              .to {
                font-size: 13px;
                font-weight: 300;
                color: $primary;
                text-align: right;
              }
              .msgPreview {
                font-size: 11px;
                font-weight: 100;
                overflow: hidden;
                text-align: right;
                max-height: 24px;
              }
            }
            i.cancelReply {
              padding: 8px;
              border-radius: 50%;
              background-color: rgba(0, 0, 0, 0.034);
              color: #848484;
              min-width: 24px;
              cursor: pointer;
            }
          }
        }
        .recordingCaption {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          top: 0;
          z-index: 5;
          pointer-events: none;
          span {
            color: #484848;
            font-size: 12px;
            font-weight: 100;
            position: relative;
            margin-left: 8px;
          }
          span::after {
            position: absolute;
            left: calc(100% + 8px);
            top: 50%;
            transform: translateY(-50%);
            content: ' ';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: red;
          }
          label {
            color: #ff0000;
            font-size: 12px;
            font-weight: 300;
            margin-left: 8px;
          }
        }
        i.delete {
          position: absolute !important;
          left: 16px;
          padding: 8px;
          cursor: pointer;
          z-index: 200;
          border-radius: 50%;
          background-color: rgba(255, 0, 0, 0.144);
          color: red;
        }
        i {
          color: #484848;
          padding: 8px;
          border-radius: 50%;
          z-index: 300000;
        }
        .emojiActive {
          color: $primary;
          background-color: #2a003a1c;
        }
        @keyframes rec {
          0% {
            box-shadow: 0 0 0 24px red, 0 0 0 24px rgba(0, 0, 0, 0.363);
          }
          50% {
            box-shadow: 0 0 0 24px red, 0 0 0 64px rgba(0, 0, 0, 0.158);
          }
          100% {
            box-shadow: 0 0 0 24px red, 0 0 0 24px rgba(0, 0, 0, 0.363);
          }
        }
        i.recording {
          background-color: red !important;
          color: white !important;
          z-index: 300000000 !important;
          animation: rec 2s cubic-bezier(1, 0, 0, 1) infinite alternate;
        }
        i:hover {
          color: $primary;
          background-color: rgba(0, 0, 0, 0.103);
        }
        input {
          flex-grow: 1;
          margin: 0 8px 0 8px;
          outline: 0;
          border: 0;
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.123);
          padding: 8px 16px;
        }
      }
      .selectedMenu {
        z-index: 50;
        position: absolute;
        z-index: 20;
        bottom: 0;
        left: 0;
        right: 0;
        height: 64px;
        padding: 0px 16px;
        transform: translateY(100%);
        background-color: white;
        box-shadow: 0 0px 24px 0 rgba($color: #000000, $alpha: 0.15);
        i.mainIcon {
          font-size: 32px;
          opacity: 0.4;
          margin-left: 16px;
          color: $primary;
        }
        .selectedsInfo {
          label {
            line-height: 1;
            font-size: 24px;
            font-weight: bold;
            color: $secondary;
            .i {
              display: inline;
              font-size: 16px;
              font-weight: 300;
              margin-right: 4px;
            }
          }
          span {
            font-size: 12px;
            font-weight: 100;
            color: #313131;
            margin-top: 0px;
          }
        }
        .selectedOptions {
          i {
            padding: 8px;
            border-radius: 50%;
          }
          i.close {
            background-color: rgba(0, 0, 0, 0.06);
          }
        }
      }
      .selectedMenu.active {
        transform: translateY(0%);
      }
      .attachHolder {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.685);
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 500000000;
        left: 0;
        .closer {
          position: absolute;
          top: 56px;
          right: 0;
          z-index: 19;
          bottom: 0;
          left: 0;
          i.close {
            position: absolute;
            top: 16px;
            right: 8px;
            color: white;
            padding: 8px;
            cursor: pointer;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.171);
          }
        }
        .attachBox {
          position: absolute;
          z-index: 22;
          bottom: 0px;
          left: 0;
          right: 0;
          height: 380px;
          background-color: white;
          box-shadow: 0 0px 24px 0 rgba($color: #000000, $alpha: 0.15);
          .contents {
            .attachPage {
              width: 100%;
              height: 100%;
              background-color: $primary;
              input {
                display: none;
              }
              .dropFile {
                border-radius: 24px;
                border: dashed 1px rgba($color: #ffffff, $alpha: 0.15);
                width: calc(100% - 32px);
                max-width: 380px;
                padding: 24px;
                * {
                  pointer-events: none;
                }
                i {
                  font-size: 48px;
                  color: rgba($color: #ffffff, $alpha: 0.45);
                }
                .title {
                  color: white;
                  font-size: 16px;
                  font-weight: 100;
                }
                .desc {
                  font-size: 10px;
                  font-weight: 100;
                  color: white;
                  direction: ltr;
                  .ext {
                    display: inline;
                    padding: 4px 8px;
                    line-height: 2;
                    border-radius: 8px;
                    background-color: rgba(0, 0, 0, 0.096);
                    color: white;
                    margin: 2px;
                  }
                }
              }
              .dropFile:hover {
                background-color: rgba(0, 0, 0, 0.062);
              }
              .dropFile.disable {
                opacity: 0.4;
                pointer-events: none;
                .desc {
                  direction: rtl;
                }
              }
            }
          }
          .bottom {
            border-top: 1px solid rgba($color: #000000, $alpha: 0.25);
            padding: 8px 0;
            .attachType {
              padding: 8px;
              min-width: 64px;
              border-radius: 48px;
              cursor: pointer;
              color: $primary;
              i.icon {
                color: #646464;
              }
              label {
                font-size: 10px;
                font-weight: 100;
                color: #161616;
              }
            }
            .attachType.selected {
              background-color: rgba($color: #000000, $alpha: 0.15);
              i.icon {
                color: $primary;
              }
            }
          }
        }
      }
      .head {
        z-index: 2235646840000000;
        height: 56px;
        position: absolute;
        padding: 0 16px;
        max-height: 464px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-shadow: 0 0 24px 0 rgba($color: #000000, $alpha: 1);
        .infos {
          height: 56px;
          position: relative;
          align-items: center;
          .avatar {
            position: absolute;
            top: 8px;
            right: 8px;
            width: $chatAvatar;
            height: $chatAvatar;
            border-radius: 50%;
            overflow: hidden;
            min-width: $chatAvatar;
            margin-left: 8px;
            box-shadow: 0 0 0 0 rgba($color: #ffffff, $alpha: 0.0);
            background-color: orange;
            img {
              position: absolute;
              width: 102%;
              height: 102%;
              top: -1%;
              left: -1%;
            }
          }
          h3 {
            color: white;
            font-size: 14px;
            font-weight: 300;
            margin: 0;
            padding: 0;
            position: absolute;
            top: 8px;
            right: 56px;
          }
          .bio {
            position: absolute;
            position: absolute;
            right: 56px;
            top: 30px;
            overflow: hidden;
            border-top: dashed 1px rgba($color: #ffffff, $alpha: 0.0);
            height: 0px;
            pointer-events: none;
            span {
              font-size: 11px;
              font-weight: 100;
              color: white;
              text-align: right;
            }
            .bioText {
              font-size: 14px;
              font-weight: 100;
              color: rgba(255, 255, 255, 0.781);
              text-align: right;
            }
          }
          .states {
            position: absolute;
            right: 56px;
            top: 30px;
            .state {
              width: 8px;
              height: 8px;
              margin-left: 8px;
              border-radius: 50%;
              background-color: rgba(255, 255, 255, 0.432);
            }
            .state.online {
              background-color: rgb(149, 230, 82);
            }
            span {
              background-color: rgba(255, 255, 255, 0.432);
              font-size: 10px;
              font-weight: 100;
              margin: 0;
              padding: 0;
            }
            span.online {
              background-color: unset;
              color: white;
            }
          }
          .option {
            position: absolute;
            top: 8px;
            left: 8px;
            i {
              color: white;
              border-radius: 50%;
              padding: 8px;
              font-size: 16px;
              cursor: pointer;
            }
            .btnOption {
              position: relative;
              i {
                color: white;
                border-radius: 50%;
                padding: 8px;
                font-size: 24px;
                cursor: pointer;
              }
              .dropDown {
                position: absolute;
                overflow: hidden;
                transform: scale(0);
                opacity: 0;
                transform-origin: top left;
                border-radius: 8px;
                z-index: 3000000;
                box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.25);
                top: 100%;
                left: 0%;
                .item {
                  width: 196px;
                  height: 48px;
                  cursor: pointer;
                  border-bottom: solid 1px rgba($color: #ffffff, $alpha: 0.05);
                  * {
                    pointer-events: none;
                  }
                  i {
                    font-size: 16px;
                  }
                  label {
                    font-size: 13px;
                    color: white;
                  }
                }
                .item:hover{
                  filter: brightness(165%);
                }
              }
            }
            .btnOption:hover .dropDown {
              transform: scale(1);
              opacity: 1;
            }
          }
        }
      }
      .head.open {
        z-index: 2235646840000000;
        height: 100%;
        position: absolute;
        padding: 0 16px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-shadow: 0 0 24px 0 rgba($color: #000000, $alpha: 1);
        .infos {
          height: 356px;
          position: relative;
          align-items: center;
          .avatar {
            position: absolute;
            top: 64px;
            right: calc(50% - 82px);
            width: $openChatAvatar;
            height: $openChatAvatar;
            border-radius: 50%;
            min-width: $openChatAvatar;
            box-shadow: 0 0 0 48px rgba($color: #ffffff, $alpha: 0.02);
            margin-left: 8px;
            background-color: orange;
          }
          .avatar.offline {
            filter: grayscale(100%);
          }
          h3 {
            color: white;
            font-size: 20px;
            font-weight: 300;
            margin: 0;
            padding: 0;
            position: absolute;
            top: 242px;
            right: 50%;
            transform: translateX(50%);
            -moz-transform: translateX(50%);
            -o-transform: translateX(50%);
            -webkit-transform: translateX(50%);
            -ms-transform: translateX(50%);
          }
          .bio {
            position: absolute;
            right: 50%;
            padding: 8px;
            transform: translateX(50%);
            -moz-transform: translateX(50%);
            -o-transform: translateX(50%);
            -webkit-transform: translateX(50%);
            -ms-transform: translateX(50%);
            border-top: dashed 1px rgba($color: #ffffff, $alpha: 0.05);
            top: 304px;
            overflow: hidden;
            pointer-events: none;
            span {
              font-size: 11px;
              font-weight: 100;
              color: rgba(255, 255, 255, 0.363);
              text-align: right;
            }
            .bioText {
              font-size: 14px;
              font-weight: 100;
              position: relative;
              color: rgba(255, 255, 255, 0.781);
              text-align: right;
              padding: 0 16px;
            }
          }
          .states {
            position: absolute;
            right: 50%;
            transform: translateX(50%);
            -moz-transform: translateX(50%);
            -o-transform: translateX(50%);
            -webkit-transform: translateX(50%);
            -ms-transform: translateX(50%);
            top: 275px;
            .state {
              width: 8px;
              height: 8px;
              margin-left: 8px;
              border-radius: 50%;
              background-color: rgba(255, 255, 255, 0.432);
            }
            .state.online {
              background-color: rgb(149, 230, 82);
            }
            span {
              background-color: rgba(255, 255, 255, 0.432);
              font-size: 10px;
              font-weight: 100;
              margin: 0;
              padding: 0;
            }
            span.online {
              background-color: unset;
              color: white;
            }
          }
          .option {
            position: absolute;
            top: 8px;
            left: 8px;
            i {
              color: white;
              border-radius: 50%;
              padding: 8px;
              font-size: 16px;
              cursor: pointer;
            }
            .btnOption {
              position: relative;
              i {
                color: white;
                border-radius: 50%;
                padding: 8px;
                font-size: 24px;
                cursor: pointer;
              }
              .dropDown {
                position: absolute;
                overflow: hidden;
                transform: scale(0);
                opacity: 0;
                transform-origin: top left;
                border-radius: 8px;
                z-index: 3000000;
                box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.25);
                top: 100%;
                left: 0%;
                .item {
                  width: 196px;
                  height: 48px;
                  cursor: pointer;
                  border-bottom: solid 1px rgba($color: #ffffff, $alpha: 0.05);
                  * {
                    pointer-events: none;
                  }
                  i {
                    font-size: 16px;
                  }
                  label {
                    font-size: 13px;
                    color: white;
                  }
                }
                .item:hover{
                  filter: brightness(165%);
                }
              }
            }
            .btnOption:hover .dropDown {
              transform: scale(1);
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .chatScreen::before {
    position: absolute;
    content: ' ';
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-image: url('../assets/pattern.svg');
    background-size: 256px;
    background-repeat: repeat;
    background-position: center;
    opacity: 0.02;
    pointer-events: none;
  }
}

// responsive
@media (orientation: landscape) {
  .fullScreenMedia {
    img.square, video.square {
      width: 90vh;
      height: 90vh;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    img.port, video.port {
      width: auto;
      height: 80vh;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    img.land, video.land {
      width: 90vh;
      height: auto;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  }
}

@media (orientation: portrait) {
  .fullScreenMedia {
    img.square, video.square {
      width: 100vw;
      height: 100vw;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    img.port, video.port {
      width: auto;
      height: 100vw;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    img.land, video.land {
      width: 100vw;
      height: auto;
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
  }
  .hideChatList {
    display: none;
  }
}

@media screen and (max-width: 400px) {
  .hideChatList {
    display: none;
  }
}

@media screen and (max-width: 600px) and (max-width: 401px) {
  .hideChatList {
    display: none;
  }
}

@media screen and (max-width: 900px) and (min-width: 601px) {
  .hideChatList {
    display: none;
  }
}

@media screen and (max-width: 1200px) and (min-width: 901px) {
  .add {
    display: none !important;
  }
  .chatScreen {
    left: 320px !important;
  }
  .chatList {
    width: 320px !important;
  }
}

@media screen and (max-width: 1600px) and (min-width: 1201px) {
  .add {
    display: none !important;
  }
  .chatContainer {
    left: 188px !important;
    right: 188px !important;
  }
  .chatScreen {
    left: 320px !important;
  }
  .chatList {
    width: 320px !important;
  }
}

@media screen and (max-width: 1800px) and (min-width: 1601px) {
  .add {
    display: none !important;
  }
  .chatContainer {
    left: 268px !important;
    right: 268px !important;
  }
  .chatScreen {
    left: 340px !important;
  }
  .chatList {
    width: 340px !important;
  }
}

@media screen and (min-width: 1800px) {
  .add {
    display: none !important;
  }
  .chatContainer {
    left: 375px !important;
    right: 375px !important;
  }
  .chatScreen {
    left: 420px !important;
  }
  .chatList {
    width: 420px !important;
  }
}
</style>
